<template>
  <section
    v-touch:swipe.prevent="preventDesktop(swipe)"
    class="sidearm-mm-reaction mobile text-white relative bg-size-cover bg-position-center relative overflow-hidden h-100"
    data-anchor="reaction"
    scrolling
  >
    <section-background css_var="--section-mobile-bg-selection-sunday-reaction"></section-background>
    <video-background
      v-if="section.background_type === 'video'"
      :video="section.background_video"
    />

    <div class="sidearm-mm-reaction__inner px-2 py-5 h-100 relative">
      <div
        :class="
          'swipe_direction_' + swipe_direction + ' swipe_step_' + swipe_step
        "
        class="sidearm-mm-reaction__details col-6-of-8 col-push-1 flex flex-column flex-align-start flex-justify-end h-100"
      >
        <transition :name="panel_transition">
          <div v-show="swipe_step === 0">
            <!-- <div class="type-heading-bracket-plain --light mb-2">Watch</div> -->

            <h2 v-if="section.title" class="type-hero mt-0 mb-4">
              {{ section.title }}
            </h2>
          </div>
        </transition>

        <transition :name="panel_transition">
          <div v-show="swipe_step === 1">
            <p v-if="section.sub_title" class="type-paragraph ma-0 mb-2 w-100 pa-2">
              {{ section.sub_title }}
            </p>

            <div v-if="section.reaction_video" class="flex flex-align-center">
              <modal-video :video="section.reaction_video">
                <button
                  slot-scope="scope"
                  type="button"
                  @click="scope.open"
                  class="sidearm-mm-play-btn"
                  aria-label="Play video: Team reaction to Selection Sunday"
                >
                  <icon>sf-play-minimal</icon>
                </button>
              </modal-video>

              <div
                v-if="section.reaction_video_play_button_label"
                class="type-heading mx-2"
              >
                {{ section.reaction_video_play_button_label }}
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true }
  },

  data: () => ({
    swipe_step: 0,
    swipe_direction: "",
    panel_transition: "down"
  }),

  computed: {
    swipe_intervals() {
      let intervals = 0;

      if (this.section.sub_title || this.section.reaction_video.id) {
        ++intervals;
      }

      return intervals;
    }
  },

  methods: {
    swipe(direction) {
      if (direction === "top") {
        this.swipe_up();
      } else if (direction === "bottom") {
        this.swipe_down();
      }
    },

    swipe_down() {
      if (this.swipe_step === 0) {
        this.moveSectionUp();
      } else {
        this.panel_transition = "up";

        if (this.swipe_step === 1 && !this.section.subtitle) {
          this.swipe_step--;
        }
        this.swipe_step--;
      }

      if (this.swipe_step < 0) {
        this.swipe_step = 0;
      }
    },

    swipe_up() {
      if (this.swipe_step >= this.swipe_intervals) {
        this.moveSectionDown();
      } else {
        this.panel_transition = "down";

        ++this.swipe_step;

        if (this.swipe_step > this.swipe_intervals) {
          this.swipe_step = this.swipe_intervals;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-reaction.mobile {
  .sidearm-mm-play-btn {
    @include play-btn(6rem);
  }
}
</style>

<style lang="scss">
.#{$prefix}-reaction.mobile {
  .up-enter-active,
  .up-leave-active {
    transition: all 0.5s ease;
  }
  .up-enter {
    transform: translateY(-25%);
    opacity: 0;
  }
  .up-leave-to {
    transform: translateY(25%);
    opacity: 0;
  }

  .down-enter-active,
  .down-leave-active {
    transition: all 0.5s ease;
  }
  .down-enter {
    transform: translateY(25%);
    opacity: 0;
  }
  .down-leave-to {
    transform: translateY(-25%);
    opacity: 0;
  }
}
</style>
